// ./src/components/layouts/BareLayout.tsx
//
// ROADMAP A2b #58 — the route layout for a page that brings its OWN full-screen shell.
//
// Since #58 every route gets `AppShellLayout` (the sidebar + header + tab bar) unless it says
// otherwise. A handful of pages must not: the print sheets (`PrintPage`), the create-event wizard
// and onboarding (deliberately distraction-light), the public auth screens (`AuthLayout`) and the
// 404 / 500 screens (`FullScreenLayout`). They declare `layout: BareLayout` — see
// `BARE_SHELL_COMPONENTS` in `siteMap.ts`, which is the one list of them.
//
// ⚠ IT IS A REAL, NAMED COMPONENT RATHER THAN OMITTING `layout`. `@sdflc/react-router-pages` falls
// back to a fragment for a layout it cannot resolve, so a typo would ALSO render bare — a print
// sheet and a page that quietly lost its whole shell would look identical in the sitemap. Naming it
// makes "this page has no shell" something that was decided, not something that happened.
import React from "react";

interface BareLayoutProps {
  children?: React.ReactNode;
}

export const BareLayout: React.FC<BareLayoutProps> = ({ children }) => <>{children}</>;
